export default "__VITE_ASSET__y2U6TvGm__"